<template lang="pug">
  main
    NavBarInventario
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.is-size-3 
              | Nueva Reasignación
              | &nbsp
              router-link.a.button.is-dark.is-rounded.is-size-6.is-medium(to="/Inventario/")
                i.fas.fa-times  
        .columns
          .column.is-4
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar por Modelo | Marca | Serie',
                  v-model="query",
                )
          .column.is-offset-5.is-3
            CarritoAsignados.is-pulled.rigth(@hover="mostrarListaCarrito" :items="articulosSelect")
            ListaArticulosAsignados(v-show="verListaCarrito" @hover="mostrarListaCarrito" @quitarArticulo_Asig="quitarArtticuloSel" :asignados="articulosSelect")
        .columns
          ListAsignaciones(:asignados="articulosShow" :nuevos="articulosSelect" @articulo_select="agregarArticuloSel")
</template>

<script>
  import NavBarInventario from './layout/NavBarInventario.vue'
  import CarritoAsignados from './CarritoAsignados.vue'
  import ListAsignaciones from './ListAsignaciones.vue'
  import ListaArticulosAsignados from './ListaArticulosAsignados.vue'
  import Loader from '../shared/Loader.vue'
  import InventarioServices from '../../services/inventario/inventario'
  import { mapState } from 'vuex'

  export default {
    name: 'NewReasignacion',
    components: { NavBarInventario, Loader, CarritoAsignados, ListAsignaciones, ListaArticulosAsignados },
    data() {
      return {
        isLoading: true,
        query: '',
        articulos: [],
        articulosShow: [],
        articulosSelect: [],
        verListaCarrito: false
      }
    },
    watch: {
      query() {
        const artFilter = this.articulos.filter( arts => { 
          return `${arts.modelo} ${arts.marca} ${arts.serie} ${arts.resguarda}`.toUpperCase().includes(this.query)
        }) 
        console.log(artFilter)
        if (artFilter.length > 0) {
          this.articulosShow = artFilter
        } else {
          this.articulosShow = this.articulos
        }
      }
    },
    methods: {
      iniciarComponente() {
        this.obtenerArticulosAsigandos()
      },
      obtenerArticulosAsigandos() {
        InventarioServices.getArticulosAsig_Ubicacion(this.userLogin.ubicacion)
          .then( data => {
            console.log(data)
            this.articulos = data
            this.articulosShow = this.articulos
            this.isLoading = false
          })
          .catch( e => console.log(e))
      },
      agregarArticuloSel (art) {
        this.articulosSelect.push(art)
      },
      quitarArtticuloSel (art) {
        var indexOfArt = this.articulosSelect.findIndex(i => i.id === art.id)
        this.articulosSelect.splice(indexOfArt,1)
      },
      mostrarListaCarrito (result) {
        this.verListaCarrito = result
      }
    },
    created () {
      this.iniciarComponente()
    },
    computed: {
      ...mapState(['userLogin'])
    }
  }
</script>

<style lang="css" scoped>

</style>


// WEBPACK FOOTER //
// src/components/inventario_Componentes/NewReasignacion.vue